module.exports = __webpack_public_path__ + "img/create_proposal.1549db69.svg";